<div class="auth-page bg-blue-500">
  <div class="auth-card">
    <div class="flex align-items-center justify-content-center mb-4">
      <img src="assets/images/logo/logo-monicase-vertical.png" alt="" class="auth-logo" />
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="password">Nouveau mot de passe</label>
        <input
          type="password"
          id="password"
          formControlName="password"
          placeholder="••••••••"
          [readOnly]="authService.isLoading"
        />
        <div class="error" *ngIf="submitted && f['password'].errors">
          <span *ngIf="f['password'].errors?.['required']">Mot de passe requis</span>
          <span *ngIf="f['password'].errors?.['minlength']">8 caractères minimum</span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirmer le mot de passe</label>
        <input
          type="password"
          id="confirmPassword"
          formControlName="confirmPassword"
          placeholder="••••••••"
          [readOnly]="authService.isLoading"
        />
        <div class="error" *ngIf="submitted && (f['confirmPassword'].errors || form.errors?.['passwordMismatch'])">
          <span *ngIf="f['confirmPassword'].errors?.['required']">Confirmation requise</span>
          <span *ngIf="form.errors?.['passwordMismatch']">Les mots de passe ne correspondent pas</span>
        </div>
      </div>

      <div class="text-green-500 mb-3" *ngIf="successMessage">
        {{ successMessage }}
      </div>
      <div class="text-red-500 mb-3" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <p-button
        type="submit"
        label="Réinitialiser"
        [loading]="authService.isLoading"
        [disabled]="authService.isLoading"
        styleClass="w-full bg-blue-500"
      ></p-button>

      <div class="mt-3 text-center">
        <a class="text-blue-500 pointer" (click)="onSignIn()">Retour à la connexion</a>
      </div>
    </form>
  </div>
</div>

